/* tslint:disable */
import {
  App,
  Entity,
  Entityrecord
} from '../index';

declare var Object: any;
export interface TimeseriesInterface {
  data: any;
  id?: any;
  appId?: any;
  entityId?: any;
  entityrecordId?: any;
  app?: App;
  entity?: Entity;
  entityrecord?: Entityrecord;
}

export class Timeseries implements TimeseriesInterface {
  data: any;
  id: any;
  appId: any;
  entityId: any;
  entityrecordId: any;
  app: App;
  entity: Entity;
  entityrecord: Entityrecord;
  constructor(data?: TimeseriesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Timeseries`.
   */
  public static getModelName() {
    return "Timeseries";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Timeseries for dynamic purposes.
  **/
  public static factory(data: TimeseriesInterface): Timeseries{
    return new Timeseries(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Timeseries',
      plural: 'timeseries',
      properties: {
        data: {
          name: 'data',
          type: 'any'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        entityId: {
          name: 'entityId',
          type: 'any'
        },
        entityrecordId: {
          name: 'entityrecordId',
          type: 'any'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
        entity: {
          name: 'entity',
          type: 'Entity',
          model: 'Entity'
        },
        entityrecord: {
          name: 'entityrecord',
          type: 'Entityrecord',
          model: 'Entityrecord'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Timeseries.ts